import RequestSender from './RequestSender.js';

function CreateOrganization(organization, files) {
    return RequestSender.PostFormData('organization/CreateOrganization', organization, files);
}

function GetAllOrganizations(){
    return RequestSender.Get('organization/GetAllOrganizations');
}

function GetOrganizationDetail(data){
    return RequestSender.Get('organization/GetOrganizationDetail', data);
}

function UpdateOrganization(data, files){
    return RequestSender.PostFormData('organization/UpdateOrganization', data, files);
}

function EnableOrganization(data){
    return RequestSender.Post('organization/EnableOrganization', data);
}

function DisableOrganization(data){
    return RequestSender.Post('organization/DisableOrganization', data);
}

export default {
    CreateOrganization, GetAllOrganizations, GetOrganizationDetail, UpdateOrganization, EnableOrganization, DisableOrganization
}